import React from 'react';
import _ from 'lodash';
import $ from 'jquery';
import Moment from 'moment';
import { Table, Column } from 'fixed-data-table';
import { filter, find, orderBy } from 'lodash';
import Select from 'react-virtualized-select';
import custJqAjax from '../../../commonJS/custJqAjax';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import { dateFormatCutter } from '../../../commonJS/formatters';
import { optsGeneratorCommon } from '../../../commonComponents/DropDownMenu';
import DayPicker from '../../../commonComponents/DayPicker';
import Uploading from '../../../commonComponents/DataLoading';
// import fakeDataA from './fakeDataA';
import { SortHeaderCell, TextCell, DataListWrapper, dataListFilterWithId } from '../../../commonComponents/DataTable/DataTablePs';

import {
	Row, Col, Modal,
	Button,
	FormGroup,
	ControlLabel, FormControl
} from 'react-bootstrap';


export function loadOptions(ownerThis, cb) {
	let apiUrl = '/api/M_Basic_Group_Data_Get.php',
		stateKey = [
			'optsTypeStatus',
			'optsStage',
			'optsTake',
			'optsModelStatus',
			'optsDelivery',
			'optsCurrency',
			'optsTax',
			'optsMchineType_sales',
			'optsMchineType_svc',
			'optsUnit',
			'optsMchineType_svc'
		];

	custJqAjax({
		type: 'GET',
		ajaxsWip: ownerThis.ajaxsWip,
		custId: ownerThis.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
		url: apiUrl,
		processData: false,
		contentType: false,
		complete: res => {
			let options = [];

			if (res.responseJSON.status === '0') {
				const data = res.responseJSON.result;

				options.push(optsGeneratorCommon(filter(data, { group_name: 'type_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'stage_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'take_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'model_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'delivery_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'currency_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'tax_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'machine_type_sales' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'machine_type_svc' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'unit_id' }), ['value', 'label'], ['key', 'value']));
				options.push(optsGeneratorCommon(filter(data, { group_name: 'machine_type_svc' }), ['value', 'label'], ['key', 'value']));
			}

			// 選項沒東西或出錯則不需更新
			if (options.length !== 0) {
				const tempObj = {};
				for (let i = stateKey.length - 1; i >= 0; i--) {
					tempObj[stateKey[i]] = options[i];
				}

				ownerThis.setState(tempObj, () => {
					// 放這裡的原因是因為要等選項 ready 才能 mapping 選項名稱
					// 用在報表時不會有formQuotationSortedData
					if (ownerThis.props.formQuotationSortedData !== undefined) {
						if (!ownerThis.props.formQuotationSortedData._data) {
							ownerThis.handlers.loadTableData();
						} else {
							ownerThis.setState({ is_loading: false });
						}
					}
				});
			}
		}
	});
}

const DropDownMenu = props => {
	const { languageData, languageCode } = window.myConsts;

	return (
		<Col sm={props.sm}>
			<FormGroup validationState={props.validationState} style={{ position: 'relative' }}>
				<ControlLabel>{props.required ? <span style={{ color: 'red' }}>* </span> : ''}<span style={{ fontWeight: 'bold' }}>{props.label}</span></ControlLabel>
				<div className={'validation-state-' + props.validationState}>
					<Select
						inputProps={{ id: props.id }}
						multi={props.multi}
						openOnFocus={true}
						disabled={props.disabled}
						value={props.value}
						valueKey={props.valueKey}
						labelKey={props.labelKey}
						matchProp='label'
						clearable={props.clearable || false}
						placeholder={
							!props.disabled
								? languageData['528'][languageCode]
								: ''
						}
						noResultsText={languageData['448'][languageCode]}
						onChange={selection => { props.onChange(selection, props.stateName); }}
						options={props.options}
						filterOptions={props.filterOptions} />
				</div>
			</FormGroup>
		</Col>
	)
};

const CloudSearchModalUd = props => {
	const { languageData, languageCode } = window.myConsts;

	const { origState, onChangeData, filterOptions, onGoSearch } = props,
		{ repair_man_data, optsReviewStatus, optsBrand, cloudSearchContent } = origState;

	let disabledStatus = false;
	if (
		cloudSearchContent.review_status_id.length <= 0 &&
		!cloudSearchContent.quotation_start_date &&
		!cloudSearchContent.quotation_end_date &&
		!cloudSearchContent.customer_name_contact_name &&
		cloudSearchContent.brand_id.length <= 0 &&
		cloudSearchContent.request_id.length <= 0 &&
		!cloudSearchContent.doc_id
	) disabledStatus = true;

	return (
		<Modal id='modal-product' onHide={props.closeModal} show={true} keyboard={false} backdrop='static' bsSize='large'>
			<Modal.Header>
				<Modal.Title>
					<span className='textLineHeight' style={{ float: 'left' }}>
						{'雲端搜尋'}
					</span>
					<Button onClick={props.closeModal} className='funBtn'>
						{languageData['452'][languageCode]}
					</Button>
					<Button onClick={onGoSearch} className='funBtn' disabled={disabledStatus}>
						{languageData['78'][languageCode]}
					</Button>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row>
					<Col sm={4}>
						<FormGroup controlId='docId'>
							<ControlLabel style={{ fontWeight: 'bold' }}>估價單編號</ControlLabel>
							<FormControl
								// disabled={!enableEdit}
								type='text'
								onChange={(e) => {
									const str = e.currentTarget.value;
									cloudSearchContent.doc_id = str;

									onChangeData(cloudSearchContent);
								}}
								value={cloudSearchContent.doc_id} />
						</FormGroup>
					</Col>
					<Col sm={4}>
						<FormGroup controlId='customerNameContactName'>
							<ControlLabel style={{ fontWeight: 'bold' }}>客戶聯絡人</ControlLabel>
							<FormControl
								// disabled={!enableEdit}
								type='text'
								onChange={(e) => {
									const str = e.currentTarget.value;
									cloudSearchContent.customer_name_contact_name = str;

									onChangeData(cloudSearchContent);
								}}
								value={cloudSearchContent.customer_name_contact_name} />
						</FormGroup>
					</Col>
					<DropDownMenu
						sm={4}
						label={'狀態'}
						multi={true}
						// disabled={!enableEdit}
						value={cloudSearchContent.review_status_id}
						valueKey='value'
						labelKey='label'
						onChange={(option) => {
							let arr = [], len = option.length;
							for (let i = 0; i < len; i++) {
								arr.push(option[i].value);
							}
							cloudSearchContent.review_status_id = arr;

							onChangeData(cloudSearchContent);
						}}
						options={optsReviewStatus}
						filterOptions={filterOptions} />
					<DropDownMenu
						sm={4}
						label={'申請人'}
						multi={true}
						// disabled={!enableEdit}
						value={cloudSearchContent.request_id}
						valueKey='id'
						labelKey='name'
						onChange={(option) => {
							let arr = [], len = option.length;
							for (let i = 0; i < len; i++) {
								arr.push(option[i].id);
							}

							cloudSearchContent.request_id = arr;

							onChangeData(cloudSearchContent);
						}}
						options={repair_man_data}
						filterOptions={filterOptions} />
					<DropDownMenu
						sm={4}
						label={'廠牌'}
						multi={true}
						// disabled={!enableEdit}
						value={cloudSearchContent.brand_id}
						valueKey='value'
						labelKey='label'
						onChange={(option) => {
							let arr = [], len = option.length;
							for (let i = 0; i < len; i++) {
								arr.push(option[i].value);
							}

							cloudSearchContent.brand_id = arr;

							onChangeData(cloudSearchContent);
						}}
						options={optsBrand}
						filterOptions={filterOptions} />
					<DayPicker
						labelFontWeight='bold'
						sm={2}
						outerLabel={'報價日期開始'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.quotation_start_date = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.quotation_start_date} />
					<DayPicker
						labelFontWeight='bold'
						sm={2}
						outerLabel={'報價日期結束'}
						// disabled={!enableEdit}
						onChange={(date) => {
							cloudSearchContent.quotation_end_date = date;

							onChangeData(cloudSearchContent);
						}}
						dayValue={cloudSearchContent.quotation_end_date} />
				</Row>
			</Modal.Body>
		</Modal>
	)
};

export default class formQuotationTableCt extends React.Component {
	constructor(props) {
		super(props);

		this.handlers = {
			onChangeCloudSearch: (type, data) => {
				switch (type) {
					case 'search':
						const { cloudSearchContent } = this.state,
							cloudSearchStr =
								`${cloudSearchContent.review_status_id && cloudSearchContent.review_status_id.length > 0 ? 'review_status_id=' + cloudSearchContent.review_status_id.join() + '&' : ''}${cloudSearchContent.quotation_start_date ? 'quotation_start_date=' + Moment(cloudSearchContent.quotation_start_date).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.quotation_end_date ? 'quotation_end_date=' + Moment(cloudSearchContent.quotation_end_date).format('YYYY-MM-DD') + '&' : ''}${cloudSearchContent.customer_name_contact_name ? 'customer_name_contact_name=' + cloudSearchContent.customer_name_contact_name + '&' : ''}${cloudSearchContent.brand_id && cloudSearchContent.brand_id.length > 0 ? 'brand_id=' + cloudSearchContent.brand_id.join() + '&' : ''}${cloudSearchContent.request_id && cloudSearchContent.request_id.length > 0 ? 'request_id=' + cloudSearchContent.request_id.join() + '&' : ''}${cloudSearchContent.doc_id ? 'doc_id=' + cloudSearchContent.doc_id + '&' : ''}`;

						this.setState({ showCloudSearchModal: false }, () => {
							if (cloudSearchStr) {
								this.setState({ cloudSearchStr, is_loading: true }, () => {
									// this.props.oldFuncExtraProps.parentStateHandler({ states: 'showCloudSearchForm', newValues: true });
									this.handlers.loadTableData(cloudSearchStr);
								})
							}
						})
						break;
					case 'change':
						this.setState({ cloudSearchContent: data })
						break;
					case 'close':
						this.setState({ showCloudSearchModal: false }, () => {
							// this.props.oldFuncExtraProps.parentStateHandler({ states: 'showCloudSearchForm', newValues: false });
						})
						break;

					default:
				}
			},
			onTableScroll: (scrollX, scrollY) => {
				// const { systemEnvironment, formQuotationSortedData } = this.props,
				// 	itemEndCount = systemEnvironment.End_Count * 1 || 100,
				// 	{ total_count } = this.state,
				// 	tableHeight = $('.public_Scrollbar_main').height();
				// 	position = $('.fixedDataTableLayout_rowsContainer>div:nth-child(3)').css('transform').split(/\w+\(|\);?/)[1].split(/,\s?/g),
				// 	tagHeight = formQuotationSortedData._data.length * 50 - 50 - tableHeight;
				return
				// if (tagHeight === Math.abs(position[5])) {
				// 	this.setState({ is_loading: true }, () => {
				// 		const newEndCount = all_data.length + itemEndCount;
				// 		if (!this.state.overItem) {


				// 			let apiUrl = `/api/M_Quotation_Data_Search_Get.php?start_count=${(all_data.length + 1)}&end_count=${newEndCount}`;
				// 			custJqAjax({
				// 				type: 'GET',
				// 				ajaxsWip: this.ajaxsWip,
				// 				custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
				// 				url: apiUrl,
				// 				success: res => {
				// 					if (res.status !== '0') {
				// 						this.props.parentStateHandler({
				// 							states: 'formQuotationSortedData',
				// 							newValues: new DataListWrapper([], [], 'company_id')
				// 						});
				// 					} else {
				// 						let defaultSortIndexes = [], processedData = [], sortedData;

				// 						const {
				// 							optsReviewStatus,
				// 							optsTypeStatus,
				// 							optsStage,
				// 							optsTake,
				// 							optsModelStatus,
				// 							optsDelivery,
				// 							optsCurrency,
				// 							optsTax,
				// 							optsMchineType_sales,
				// 							optsMchineType_svc,
				// 							optsBrand
				// 						} = this.state;

				// 						const sortData = orderBy(res.result, ['doc_id'], ['desc']);

				// 						for (let i = 0, len = sortData.length; i < len; i++) {
				// 							defaultSortIndexes.push(i);
				// 							// 時間格式處理
				// 							const tempObj = dateFormatCutter(sortData[i], ['quotation_date', 'expiry_date'], '', true);

				// 							if (tempObj.review_status_id) {
				// 								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
				// 								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
				// 							}

				// 							if (tempObj.b_type_id) {
				// 								const tarObj = find(optsTypeStatus, { value: tempObj.b_type_id });
				// 								tempObj['typeName'] = tarObj ? tarObj.label : '';

				// 								if (tarObj) {
				// 									switch (tempObj.b_type_id) {
				// 										case '1':
				// 											if (tempObj.b_machine_type) {
				// 												const tarObj = find(optsMchineType_sales, { value: tempObj.b_machine_type });
				// 												tempObj['machineName'] = tarObj ? tarObj.label : '';
				// 											}
				// 											break;
				// 										case '2':
				// 											if (tempObj.b_machine_type) {
				// 												const tarObj = find(optsMchineType_svc, { value: tempObj.b_machine_type });
				// 												tempObj['machineName'] = tarObj ? tarObj.label : '';
				// 											}
				// 											break;

				// 										default:
				// 									}
				// 								}
				// 							}

				// 							if (tempObj.b_stage_id) {
				// 								const tarObj = find(optsStage, { value: tempObj.b_stage_id });
				// 								tempObj['stageName'] = tarObj ? tarObj.label : '';
				// 							}

				// 							if (tempObj.b_take_id) {
				// 								const tarObj = find(optsTake, { value: tempObj.b_take_id });
				// 								tempObj['takeName'] = tarObj ? tarObj.label : '';
				// 							}

				// 							if (tempObj.b_model_id) {
				// 								const tarObj = find(optsModelStatus, { value: tempObj.b_model_id });
				// 								tempObj['modelName'] = tarObj ? tarObj.label : '';
				// 							}

				// 							if (tempObj.b_delivery_id) {
				// 								const tarObj = find(optsDelivery, { value: tempObj.b_delivery_id });
				// 								tempObj['deliveryName'] = tarObj ? tarObj.label : '';
				// 							}

				// 							if (tempObj.b_currency_id) {
				// 								const tarObj = find(optsCurrency, { value: tempObj.b_currency_id });
				// 								tempObj['currencyName'] = tarObj ? tarObj.label : '';
				// 							}

				// 							if (tempObj.b_tax_id) {
				// 								const tarObj = find(optsTax, { value: tempObj.b_tax_id });
				// 								tempObj['taxName'] = tarObj ? tarObj.label : '';
				// 							}

				// 							if (tempObj.brand_id) {
				// 								let brandID = tempObj.brand_id, brandArr = brandID.split(','), brandString = '';

				// 								for (let idxBrandArr = 0; idxBrandArr < brandArr.length; idxBrandArr++) {
				// 									const tarObj = find(optsBrand, { value: $.trim(brandArr[idxBrandArr]) });

				// 									brandString += tarObj ? tarObj.label + '、' : '';
				// 								}
				// 								tempObj['brandName'] = brandString ? brandString.substring(0, brandString.length - 1) : '';
				// 							}

				// 							processedData.push(tempObj);
				// 						}

				// 						sortedData = new DataListWrapper(defaultSortIndexes, processedData, 'company_id');

				// 						this.props.parentStateHandler({ states: 'formQuotationSortedData', newValues: sortedData });
				// 					}

				// 					this.setState({ is_loading: false });
				// 				}
				// 			});
				// 		}

				// 		if (newEndCount >= total_count) this.setState({ overItem: true })
				// 	})
				// }
			},
			onCloseModal: (...params) => {
				// for customer tab
				this.setState({
					selectedRowIndex: '',
					selectedItemId: ''
				});

				props.closeModal(...params);
			},
			onRowClick: (e, rowIndex, sortedData) => {
				// this.setState({ is_loading: true })

				// let apiUrl = '/api/M_Quotation_Export_Xls.php',
				// 	doc_id = sortedData.getObjectAt(rowIndex).doc_id;

				// custJqAjax({
				// 	type: 'GET',
				// 	ajaxsWip: this.ajaxsWip,
				// 	custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
				// 	url: apiUrl,
				// 	data: { doc_id },
				// 	success: res => {
				// 		this.setState({ is_loading: false })

				// 		if (res.status === '0') {
				// 			let link = document.createElement('a');
				// 			link.href = res.result;
				// 			link.click();
				// 		}
				// 	},
				// 	error: (xhr, status, error) => { }
				// });

				const doc_id = sortedData.getObjectAt(rowIndex).doc_id;

				// 檢查匯出pdf tooltip是否已存在，若是則關閉
				if ($('#popover-trigger-click')[0]) {
					$('#btnPDFBatchExport').click();
				}
				// 判斷是否來自客戶tab
				if (this.props.onTabTableRowClick) {
					// 單純用來產生modal
					this.props.onTabTableRowClick(doc_id);
				} else {
					this.props.routeHandler(`/salesky/form-quotation/${doc_id}`);
				}

				this.setState({
					selectedRowIndex: rowIndex,
					selectedItemId: doc_id
				});
			},
			onSortChange: (columnKey, sortDir, SortTypes, indexes, data) => {
				// 前3個參數預設由子元件傳入，後兩個視使用當下情況自行傳入
				let sortIndexes = indexes || this.props.formQuotationSortedData._indexMap;
				const orinData = data || this.props.formQuotationSortedData._data;

				sortIndexes.sort((indexA, indexB) => {

					const valueA = orinData[indexA][columnKey];
					const valueB = orinData[indexB][columnKey];
					let sortVal = 0;
					if (valueA > valueB) {
						sortVal = 1;
					}
					if (valueA < valueB) {
						sortVal = -1;
					}
					if (sortVal !== 0 && sortDir === SortTypes.ASC) {
						sortVal *= -1;
					}

					return sortVal;
				});

				this.props.parentStateHandler({
					states: ['formQuotationSortedData', 'formQuotationColSortDirs'],
					newValues: [
						new DataListWrapper(sortIndexes, orinData, 'company_id'),
						{
							[columnKey]: sortDir
						}
					]
				});
			},
			loadTableData: (cloudSearchStr = '', start_count = 1, end_count = '') => {
				const { systemEnvironment } = this.props.propsPackageFromSkyFamily;

				let newEndCount =
					systemEnvironment &&
						systemEnvironment.End_Count
						? systemEnvironment.End_Count * 1
						: 100

				let apiUrl;
				if (!this.props.params) apiUrl = `/api/M_Quotation_Data_Search_Get.php?company_id=${this.props.company_id}&start_count=${start_count}&end_count=${end_count || newEndCount}`;
				else apiUrl = `/api/M_Quotation_Data_Search_Get.php?${cloudSearchStr}start_count=${start_count}&end_count=${end_count || newEndCount}`;

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: apiUrl,
					success: res => {
						let sortedData = new DataListWrapper([], [], 'company_id'), total_count = 0;

						if (res.status === '0') {
							const {
								optsReviewStatus,
								optsTypeStatus,
								optsStage,
								optsTake,
								optsModelStatus,
								optsDelivery,
								optsCurrency,
								optsTax,
								optsMchineType_sales,
								optsMchineType_svc,
								optsBrand
							} = this.state;

							total_count = res.total_count * 1

							let defaultSortIndexes = [], processedData = [];

							const sortData = orderBy(res.result, ['doc_id'], ['desc']);

							for (let i = 0, len = sortData.length; i < len; i++) {
								defaultSortIndexes.push(i);
								// 時間格式處理
								const tempObj = dateFormatCutter(sortData[i], ['quotation_date', 'expiry_date'], '', true);

								if (tempObj.review_status_id) {
									const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
									tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
								}

								if (tempObj.b_type_id) {
									const tarObj = find(optsTypeStatus, { value: tempObj.b_type_id });
									tempObj['typeName'] = tarObj ? tarObj.label : '';

									if (tarObj) {
										switch (tempObj.b_type_id) {
											case '1':
												if (tempObj.b_machine_type) {
													const tarObj = find(optsMchineType_sales, { value: tempObj.b_machine_type });
													tempObj['machineName'] = tarObj ? tarObj.label : '';
												}
												break;
											case '2':
												if (tempObj.b_machine_type) {
													const tarObj = find(optsMchineType_svc, { value: tempObj.b_machine_type });
													tempObj['machineName'] = tarObj ? tarObj.label : '';
												}
												break;

											default:
										}
									}
								}

								if (tempObj.b_stage_id) {
									const tarObj = find(optsStage, { value: tempObj.b_stage_id });
									tempObj['stageName'] = tarObj ? tarObj.label : '';
								}

								if (tempObj.b_take_id) {
									const tarObj = find(optsTake, { value: tempObj.b_take_id });
									tempObj['takeName'] = tarObj ? tarObj.label : '';
								}

								if (tempObj.b_model_id) {
									const tarObj = find(optsModelStatus, { value: tempObj.b_model_id });
									tempObj['modelName'] = tarObj ? tarObj.label : '';
								}

								if (tempObj.b_delivery_id) {
									const tarObj = find(optsDelivery, { value: tempObj.b_delivery_id });
									tempObj['deliveryName'] = tarObj ? tarObj.label : '';
								}

								if (tempObj.b_currency_id) {
									const tarObj = find(optsCurrency, { value: tempObj.b_currency_id });
									tempObj['currencyName'] = tarObj ? tarObj.label : '';
								}

								if (tempObj.b_tax_id) {
									const tarObj = find(optsTax, { value: tempObj.b_tax_id });
									tempObj['taxName'] = tarObj ? tarObj.label : '';
								}

								if (tempObj.brand_id) {
									let brandID = tempObj.brand_id, brandArr = brandID.split(','), brandString = '';

									for (let idxBrandArr = 0; idxBrandArr < brandArr.length; idxBrandArr++) {
										const tarObj = find(optsBrand, { value: $.trim(brandArr[idxBrandArr]) });

										brandString += tarObj ? tarObj.label + '、' : '';
									}
									tempObj['brandName'] = brandString ? brandString.substring(0, brandString.length - 1) : '';
								}

								processedData.push(tempObj);
							}

							sortedData = new DataListWrapper(defaultSortIndexes, processedData, 'company_id');

							// this.props.parentStateHandler({ states: 'formQuotationSortedData', newValues: sortedData });
						}

						this.props.parentStateHandler({
							states: 'formQuotationSortedData',
							newValues: sortedData
						});

						this.setState({ total_count, is_loading: false });
					}
				});
			},
			tabDataFilter: (sourceDataObj) => {
				if (!sourceDataObj._data) {
					return {};
				}

				const companyId = this.props.customerCompanyId;

				return dataListFilterWithId(sourceDataObj, companyId, true);
			},
			loadOptions: (cb) => {
				loadOptions(this, cb);
			},
			reload: () => {
				this.handlers.loadTableData();
			}
		};

		this.parentStateHandler = ({ states, newValues, cb }) => {
			parentStateHandler({ states, newValues, parentThis: this, cb });
		};

		this.ajaxsWip = [];

		// this.timer = {};

		this.state = {
			showCloudSearchModal: false,
			cloudSearchContent:
			{
				review_status_id: [],
				quotation_start_date: null,
				quotation_end_date: null,
				customer_name_contact_name: '',
				brand_id: [],
				request_id: [],
				doc_id: ''
			},
			cloudSearchStr: '',
			selectedRowIndex: '',
			selectedItemId: '',
			overItem: false,
			total_count: 0,
			is_loading: true,
			doSearchUpdate: 0,
			// 儲存key part list
			// allKeyPartsData: [],
			// loadedPartsNum: -1,
			company_data: [],
			factory_data: [],
			area_data: [],
			repair_man_data: [],
			assign_data: [],
			optsReviewStatus: [],
			optsTypeStatus: [],
			optsStage: [],
			optsTake: [],
			optsModelStatus: [],
			optsDelivery: [],
			optsCurrency: [],
			optsTax: [],
			optsMchineType_sales: [],
			optsMchineType_svc: [],
			optsBrand: [],
			optsUnit: [],
			optsPaymentRemark: []
		};
	}

	componentDidMount() {
		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_Brand_Ref_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = res.responseJSON.result;

					this.setState({
						optsBrand: optsGeneratorCommon(data, ['value', 'label'], ['id', 'brand_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_Flowstatus_Ref_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const data = res.responseJSON.result;

					this.setState({
						optsReviewStatus: optsGeneratorCommon(data, ['value', 'label'], ['flowstatus_id', 'flowstatus_name'])
					})
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_SaleSky_Users.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const repair_man_data = res.responseJSON.result;

					this.setState({ repair_man_data })
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_ServiceSky_Fix_User_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const assign_data = res.responseJSON.result;

					this.setState({ assign_data })
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_SaleSky_Company_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const company_data = res.responseJSON.result;
					// const company_data = optsGeneratorCommon(res.responseJSON.result, ['id'], ['customer_id'], true);

					this.setState({ company_data })
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_ServiceSky_System_Customer_Factory_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const factory_data = res.responseJSON.result;

					this.setState({ factory_data })
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/W_ServiceSky_RepairSky_Area_Type_Lang_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const area_data = res.responseJSON.result;

					this.setState({ area_data })
				}
			}
		});

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url: '/api/M_Payment_Sample_Get.php',
			processData: false,
			contentType: false,
			complete: res => {
				if (res.responseJSON.status === '0') {
					const optsPaymentRemark = optsGeneratorCommon(res.responseJSON.result, ['value', 'label'], ['payment_id', 'content_title'], true);

					this.setState({ optsPaymentRemark })
				}
			}
		});

		this.handlers.loadOptions();
		// this.handlers.loadTableData();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.doSearchUpdate) {
			this.setState({ doSearchUpdate: 0 });

			// 在客戶資訊底下不會有router傳入
			if (this.props.router) {
				this.props.updateSearchResults();
			}
		}

		if (
			this.props.oldFuncExtraProps.showCloudSearchForm !== prevProps.oldFuncExtraProps.showCloudSearchForm
		) {
			if (this.props.oldFuncExtraProps.showCloudSearchForm) this.setState({ showCloudSearchModal: true })
			else if (!this.props.oldFuncExtraProps.showCloudSearchForm) {
				this.setState({ cloudSearchStr: '', is_loading: true }, () => {
					this.handlers.loadTableData();
				})
			}
		}
	}

	componentWillUnmount() {
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
	}

	filterOptions(optsObjArr, stringFilter, selectedOptions) {
		const vaildOptions = _.difference(optsObjArr, selectedOptions);
		// 轉小寫的選項arr應該以state存起來避免每次重運算，只在opts更新時做更新
		// 如果運算loading相對小，不儲存可以節省記憶體，依情境取捨
		let filteredOptsObjArr = [];
		if (stringFilter) {
			let stringFilterLowerCase = stringFilter.toLowerCase();

			_.forEach(vaildOptions, (val, key) => {
				if (
					(
						val.name &&
						val.name.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					) ||
					(
						val.label &&
						val.label.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					)
				) {
					filteredOptsObjArr.push(val);
				}
			});
		} else {
			filteredOptsObjArr = vaildOptions;
		}

		return filteredOptsObjArr;
	}

	render() {
		const props = this.props, state = this.state,
			{ formQuotationColSortDirs } = props;

		let { formQuotationSortedData } = props;

		// search process
		let sortFunc = this.handlers.onSortChange;
		if (props.searchResults._data) {
			formQuotationSortedData = props.searchResults;
			sortFunc = '';
		}

		// customer tab的情況下過濾公司
		if (props.customerCompanyId) {
			formQuotationSortedData = this.handlers.tabDataFilter(formQuotationSortedData);
		}

		let
			filter_data = formQuotationSortedData ? formQuotationSortedData._data : [],
			modal =
				props.children ?
					React.cloneElement(props.children, {
						filter_data,
						userPermission: props.userPermission,
						closeModal: this.handlers.onCloseModal,
						reload: this.handlers.reload,
						propsPackageFromSkyFamily: props.propsPackageFromSkyFamily,
						// modal更新的始終是篩選前的資料
						sortedData: props.formQuotationSortedData,
						// for pagerUd
						filteredSortedData: formQuotationSortedData,
						loadOptions: this.handlers.loadOptions,
						company_data: state.company_data,
						factory_data: state.factory_data,
						area_data: state.area_data,
						repair_man_data: state.repair_man_data,
						assign_data: state.assign_data,
						optsCompany: state.optsCompany,
						optsReviewStatus: state.optsReviewStatus,
						optsTypeStatus: state.optsTypeStatus,
						optsStage: state.optsStage,
						optsTake: state.optsTake,
						optsModelStatus: state.optsModelStatus,
						optsDelivery: state.optsDelivery,
						optsCurrency: state.optsCurrency,
						optsTax: state.optsTax,
						optsMchineType_sales: state.optsMchineType_sales,
						optsMchineType_svc: state.optsMchineType_svc,
						optsBrand: state.optsBrand,
						optsUnit: state.optsUnit,
						optsPaymentRemark: state.optsPaymentRemark,
						grandStateHandler: props.stateHandler, // 上上上層
						stateHandler: props.parentStateHandler, // 上上層
						parentStateHandler: this.parentStateHandler, // 上層
						selectedRowIndex: state.selectedRowIndex,
						selectedItemId: state.selectedItemId,
						productProps: props.productProps,
						user_id: props.userId,
						user_name: props.userName
					})
					: '',
			tableWidth = props.tabWidth || ((props.isBigSideBar ? 0 : 186) + props.tableWidth),
			tableHeight = props.tabHeight || (props.tableHeight || 477);

		return (
			<div id='div-product-content-container' className='customer-tabs-table'>

				<Uploading ref='uploading' isShow={state.is_loading} />

				{
					formQuotationSortedData &&
						formQuotationSortedData._data ?
						<Table
							onRowClick={(e, rowIndex) => { this.handlers.onRowClick(e, rowIndex, formQuotationSortedData); }}
							rowHeight={50}
							headerHeight={50}
							rowsCount={formQuotationSortedData.getSize()}
							// onScrollEnd={(x, y) => { this.handlers.onTableScroll(x, y) }}
							width={tableWidth}
							height={tableHeight}>
							<Column
								columnKey='doc_id'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.doc_id}>
										{'單號'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={110}
							/>

							<Column
								columnKey='reviewStatusName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.reviewStatusName}>
										{'狀態'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='typeName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.typeName}>
										{'表單類型'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='stageName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.stageName}>
										{'案況進度'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={215}
							/>

							<Column
								columnKey='takeName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.takeName}>
										{'預計取件'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='modelName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.modelName}>
										{'商業模式'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='request_name'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.request_name}>
										{'申請人'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='quotation_date'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.quotation_date}>
										{'報價日期'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='expiry_date'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.expiry_date}>
										{'有效日期'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='deliveryName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.deliveryName}>
										{'取件方式'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={110}
							/>

							<Column
								columnKey='customer_id'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.customer_id}>
										{'客戶編號'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='customer_name'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.customer_name}>
										{'客戶名稱'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={1}
								width={200}
							/>

							<Column
								columnKey='customer_address'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.customer_address}>
										{'客戶地址'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={1}
								width={250}
							/>

							<Column
								columnKey='contact_name'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.contact_name}>
										{'聯絡人'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='contact_tel'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.contact_tel}>
										{'聯絡電話'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={120}
							/>

							<Column
								columnKey='contact_email'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.contact_email}>
										{'Email'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={200}
							/>

							<Column
								columnKey='currencyName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.currencyName}>
										{'幣別'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='taxName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.taxName}>
										{'稅別'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='machineName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.machineName}>
										{'產品類型'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>

							<Column
								columnKey='brandName'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.brandName}>
										{'廠牌'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={150}
							/>

							<Column
								columnKey='creator_name'
								header={
									<SortHeaderCell
										onSortChange={sortFunc}
										sortDir={formQuotationColSortDirs.creator_name}>
										{'建立者'}
									</SortHeaderCell>
								}
								cell={<TextCell sortedData={formQuotationSortedData} />}
								flexGrow={0}
								width={100}
							/>
						</Table>
						: 'Data loading...'
				}

				{modal}

				{
					state.showCloudSearchModal ?
						<CloudSearchModalUd
							origProps={this.props}
							origState={this.state}
							onGoSearch={(str) => { this.handlers.onChangeCloudSearch('search', str) }}
							onChangeData={(data) => { this.handlers.onChangeCloudSearch('change', data) }}
							closeModal={() => { this.handlers.onChangeCloudSearch('close') }}
							filterOptions={this.filterOptions}
						/>
						: ''
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/formList/formQuotationTableCt.jsx